export interface IconDef {
  viewBox: string;
  content: string;
  filter?: string;
  strokeWidth?: number;
}

const ICON_REGISTRY_INTERNAL = {
  bot: {
    viewBox: '0 0 24 24',
    strokeWidth: 1.25,
    filter: 'url(#lp-shadow)',
    content: `<rect x="4" y="5" width="16" height="14" rx="3" fill="url(#lp-surface)" stroke="currentColor" stroke-width="1.25"/>
<rect x="4.75" y="5.75" width="14.5" height="3.5" rx="1.5" fill="url(#lp-highlight)" stroke="none"/>
<line x1="12" y1="1" x2="12" y2="5" stroke="currentColor" stroke-width="1.25"/>
<line x1="12" y1="1" x2="14.5" y2="0" stroke="currentColor" stroke-width="1"/>
<circle cx="14.5" cy="0" r="1" fill="currentColor" stroke="none"/>
<rect x="6.5" y="10" width="11" height="2.5" rx="1.25" fill="currentColor" stroke="none" opacity="0.9"/>
<path d="M9,16 L12,17.5 L15,16" fill="none" stroke="currentColor" stroke-width="0.75"/>`,
  },

  checkmark: {
    viewBox: '0 0 24 24',
    strokeWidth: 2.5,
    content: `<polyline points="4,12 9,17 20,6"/>`,
  },

  pause: {
    viewBox: '0 0 24 24',
    strokeWidth: 0.75,
    filter: 'url(#lp-shadow)',
    content: `<rect x="5" y="4" width="5" height="16" rx="2" fill="url(#lp-surface)" stroke="currentColor" stroke-width="0.75"/>
<rect x="5.5" y="4.5" width="4" height="4" rx="1.5" fill="url(#lp-highlight)" stroke="none"/>
<rect x="14" y="4" width="5" height="16" rx="2" fill="url(#lp-surface)" stroke="currentColor" stroke-width="0.75"/>
<rect x="14.5" y="4.5" width="4" height="4" rx="1.5" fill="url(#lp-highlight)" stroke="none"/>`,
  },

  celebration: {
    viewBox: '0 0 24 24',
    strokeWidth: 1.25,
    filter: 'url(#lp-glow-gold)',
    content: `<path d="M12,1 L14,9 L22,12 L14,15 L12,23 L10,15 L2,12 L10,9 Z" fill="url(#lp-surface)" stroke="currentColor" stroke-width="1"/>
<path d="M12,1 L14,9 L12,9.5 L10,9 Z" fill="url(#lp-highlight)" stroke="none"/>
<line x1="18" y1="3" x2="19.5" y2="4.5" stroke-width="1" stroke-opacity="0.6"/>
<line x1="19" y1="3" x2="18.5" y2="4.5" stroke-width="1" stroke-opacity="0.6"/>
<line x1="4" y1="18" x2="5.5" y2="19.5" stroke-width="1" stroke-opacity="0.5"/>
<line x1="5" y1="18" x2="4.5" y2="19.5" stroke-width="1" stroke-opacity="0.5"/>
<circle cx="12" cy="12" r="1.25" fill="currentColor" stroke="none"/>`,
  },

  trophy: {
    viewBox: '0 0 24 24',
    strokeWidth: 1.25,
    filter: 'url(#lp-glow-gold)',
    content: `<path d="M6,3 H18 L17,5 H7 Z" fill="url(#lp-surface)" stroke="currentColor" stroke-width="0.75"/>
<path d="M7,5 H17 V10 Q17,15.5 12,15.5 Q7,15.5 7,10 Z" fill="url(#lp-surface)" stroke="currentColor" stroke-width="1"/>
<path d="M8,5.5 Q8,5.5 16,5.5 L15.5,8 Q12,9 8.5,8 Z" fill="url(#lp-highlight)" stroke="none"/>
<path d="M7,7 Q3,7 3,10.5 Q3,13.5 7,13.5" fill="none" stroke="currentColor" stroke-width="1"/>
<path d="M17,7 Q21,7 21,10.5 Q21,13.5 17,13.5" fill="none" stroke="currentColor" stroke-width="1"/>
<line x1="12" y1="15.5" x2="12" y2="19" stroke="currentColor" stroke-width="1"/>
<rect x="7" y="19" width="10" height="2.5" rx="1.25" fill="url(#lp-surface)" stroke="currentColor" stroke-width="1"/>`,
  },

  'letter-grid': {
    viewBox: '0 0 24 24',
    strokeWidth: 0.75,
    filter: 'url(#lp-shadow)',
    content: `<rect x="2" y="7" width="3.5" height="4.5" rx="0.75" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
<rect x="6" y="7" width="3.5" height="4.5" rx="0.75" fill="url(#lp-surface)" stroke="currentColor" stroke-width="0.5"/>
<rect x="10" y="7" width="3.5" height="4.5" rx="0.75" fill="url(#lp-surface)" stroke="currentColor" stroke-width="0.5"/>
<rect x="14" y="7" width="3.5" height="4.5" rx="0.75" fill="url(#lp-surface)" stroke="currentColor" stroke-width="0.5"/>
<rect x="18" y="7" width="3.5" height="4.5" rx="0.75" fill="url(#lp-surface)" stroke="currentColor" stroke-width="0.5"/>
<rect x="2" y="13" width="3.5" height="4.5" rx="0.75" fill="url(#lp-surface)" stroke="currentColor" stroke-width="0.5"/>
<rect x="6" y="13" width="3.5" height="4.5" rx="0.75" fill="url(#lp-surface)" stroke="currentColor" stroke-width="0.5"/>
<rect x="10" y="13" width="3.5" height="4.5" rx="0.75" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
<rect x="14" y="13" width="3.5" height="4.5" rx="0.75" fill="url(#lp-surface)" stroke="currentColor" stroke-width="0.5"/>
<rect x="18" y="13" width="3.5" height="4.5" rx="0.75" fill="url(#lp-surface)" stroke="currentColor" stroke-width="0.5"/>`,
  },

  'word-search': {
    viewBox: '0 0 24 24',
    strokeWidth: 1,
    filter: 'url(#lp-shadow)',
    content: `<circle cx="10.5" cy="10.5" r="6.5" fill="url(#lp-surface)" stroke="currentColor" stroke-width="1.25"/>
<path d="M5,8 A6.5,6.5 0 0,1 16,8" fill="url(#lp-highlight)" stroke="none"/>
<text x="10.5" y="13.5" text-anchor="middle" font-family="var(--font-mono)" font-size="8" font-weight="700" fill="currentColor" stroke="none" opacity="0.8">A</text>
<line x1="15.5" y1="15.5" x2="21" y2="21" stroke-width="2.5" stroke="currentColor"/>`,
  },

  stopwatch: {
    viewBox: '0 0 24 24',
    strokeWidth: 1,
    filter: 'url(#lp-shadow)',
    content: `<rect x="10.5" y="1" width="3" height="3.5" rx="1" fill="url(#lp-surface)" stroke="currentColor" stroke-width="0.75"/>
<rect x="19.5" y="6" width="2.5" height="1.75" rx="0.75" fill="url(#lp-surface)" stroke="currentColor" stroke-width="0.75" transform="rotate(-30 20.75 6.875)"/>
<circle cx="12" cy="13.5" r="8.5" fill="url(#lp-surface)" stroke="currentColor" stroke-width="1"/>
<path d="M4.5,11 A8.5,8.5 0 0,1 19.5,11" fill="url(#lp-highlight)" stroke="none"/>
<line x1="12" y1="6" x2="12" y2="7.5" stroke-width="1.25"/>
<line x1="19.5" y1="13.5" x2="18" y2="13.5" stroke-width="1.25"/>
<line x1="12" y1="21" x2="12" y2="19.5" stroke-width="1.25"/>
<line x1="4.5" y1="13.5" x2="6" y2="13.5" stroke-width="1.25"/>
<line x1="12" y1="13.5" x2="12" y2="7" stroke-width="1.5"/>
<line x1="12" y1="13.5" x2="15.5" y2="11" stroke-width="1"/>
<circle cx="12" cy="13.5" r="1" fill="currentColor" stroke="none"/>`,
  },

  'stopwatch-minimal': {
    viewBox: '0 0 24 24',
    strokeWidth: 1.5,
    content: `<rect x="10.5" y="1" width="3" height="3.5" rx="1" fill="url(#lp-surface)" stroke="currentColor" stroke-width="1"/>
<circle cx="12" cy="13.5" r="8.5" fill="url(#lp-surface)" stroke="currentColor" stroke-width="1"/>
<line x1="12" y1="13.5" x2="12" y2="7" stroke-width="1.5"/>
<circle cx="12" cy="13.5" r="1" fill="currentColor" stroke="none"/>`,
  },

  'close-x': {
    viewBox: '0 0 24 24',
    strokeWidth: 1.5,
    content: `<line x1="5" y1="5" x2="19" y2="19"/>
<line x1="19" y1="5" x2="5" y2="19"/>`,
  },

  clipboard: {
    viewBox: '0 0 24 24',
    strokeWidth: 1,
    filter: 'url(#lp-shadow)',
    content: `<rect x="5" y="4" width="14" height="17" rx="1.5" fill="url(#lp-surface)" stroke="currentColor" stroke-width="1"/>
<rect x="5.5" y="4.5" width="13" height="3.5" rx="1" fill="url(#lp-highlight)" stroke="none"/>
<rect x="9" y="2" width="6" height="4" rx="1" fill="url(#lp-surface)" stroke="currentColor" stroke-width="1"/>
<rect x="10.5" y="3" width="3" height="2" rx="0.5" fill="none" stroke="currentColor" stroke-width="0.75" opacity="0.5"/>
<line x1="8" y1="10" x2="16" y2="10" stroke-opacity="0.7" stroke-width="1"/>
<line x1="8" y1="13.5" x2="16" y2="13.5" stroke-opacity="0.7" stroke-width="1"/>
<line x1="8" y1="17" x2="13" y2="17" stroke-opacity="0.7" stroke-width="1"/>`,
  },

  warning: {
    viewBox: '0 0 24 24',
    strokeWidth: 1,
    filter: 'url(#lp-shadow)',
    content: `<path d="M12,3 L22,21 H2 Z" fill="url(#lp-warning)" stroke="currentColor" stroke-width="1" stroke-linejoin="round"/>
<path d="M12,4.5 L20,19 H13 Z" fill="url(#lp-highlight)" stroke="none"/>
<line x1="12" y1="9" x2="12" y2="15" stroke-width="2"/>
<circle cx="12" cy="18.5" r="1.25" fill="currentColor" stroke="none"/>`,
  },

  'warning-inline': {
    viewBox: '0 0 24 24',
    strokeWidth: 1.5,
    content: `<path d="M12,3 L22,21 H2 Z" fill="none" stroke-linejoin="round"/>
<line x1="12" y1="9" x2="12" y2="15" stroke-width="2"/>
<circle cx="12" cy="18.5" r="1.25" fill="currentColor" stroke="none"/>`,
  },

  'alarm-clock': {
    viewBox: '0 0 24 24',
    strokeWidth: 1.25,
    filter: 'url(#lp-shadow)',
    content: `<path d="M4,7 A3.5,3.5 0 0,1 9,5" fill="url(#lp-surface)" stroke-width="1"/>
<path d="M20,7 A3.5,3.5 0 0,0 15,5" fill="url(#lp-surface)" stroke-width="1"/>
<line x1="12" y1="2.5" x2="12" y2="5" stroke-width="1.5"/>
<circle cx="12" cy="2" r="0.75" fill="currentColor" stroke="none"/>
<circle cx="12" cy="14" r="8" fill="url(#lp-surface)" stroke="currentColor" stroke-width="1"/>
<path d="M5,11.5 A8,8 0 0,1 19,11.5" fill="url(#lp-highlight)" stroke="none"/>
<line x1="12" y1="14" x2="12" y2="8"/>
<line x1="12" y1="14" x2="16" y2="11"/>
<circle cx="12" cy="14" r="1" fill="currentColor" stroke="none"/>
<line x1="5" y1="21" x2="7" y2="19.5" stroke-width="1.25"/>
<line x1="19" y1="21" x2="17" y2="19.5" stroke-width="1.25"/>`,
  },

  refresh: {
    viewBox: '0 0 24 24',
    strokeWidth: 1.5,
    content: `<path d="M20,12 A8,8 0 0,0 12,4" fill="none"/>
<polyline points="15,1 12,4 15,7"/>
<path d="M4,12 A8,8 0 0,0 12,20" fill="none"/>
<polyline points="9,23 12,20 9,17"/>`,
  },

  gear: {
    viewBox: '0 0 24 24',
    strokeWidth: 1.5,
    content: `<circle cx="12" cy="12" r="3"/>
<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" fill="none"/>`,
  },

  'error-x': {
    viewBox: '0 0 24 24',
    strokeWidth: 1,
    filter: 'url(#lp-glow-danger)',
    content: `<circle cx="12" cy="12" r="9" fill="url(#lp-danger)" stroke-width="1"/>
<line x1="8" y1="8" x2="16" y2="16" stroke-width="1.75"/>
<line x1="16" y1="8" x2="8" y2="16" stroke-width="1.75"/>`,
  },
} as const satisfies Record<string, IconDef>;

export type IconName = keyof typeof ICON_REGISTRY_INTERNAL;
export const ICON_REGISTRY: Readonly<Record<IconName, IconDef>> = ICON_REGISTRY_INTERNAL;
